export enum SharedQueryParams {
  ValuesId = 'values_id',
}
